import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { paths } from './utils/paths'

// eslint-disable-next-line react/prop-types
function Nav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isPathActive = (path) => {
    return pathname === path || pathname.startsWith(path) ? 'activeLink' : '';
  };

  const generateLinks = (pathsArray) => 
    pathsArray
      .filter(path => path.roles.includes(user.role))
      .map((path) => (
        <Link key={path.label} to={path.path} className={isPathActive(path.path)}>
          {path.label}
        </Link>
      ));

  return (
    <div className="buttonLinks">
      <div className="navbar">
        {/* <div className="topNavbar">
          <div className="centeredLink">
            <Link to="/" className={isPathActive('/')}>
              Home
            </Link>
          </div>
        </div> */}
        <div className="mainNavbar">{generateLinks(paths)}</div>
        {paths
          .filter(path => path.roles.includes(user.role))
          .map((path) => (
            pathname.startsWith(path.path) && (
              <div key={path.label} className="subNavbar">
                {path.subPaths
                  .filter(subPath => subPath.roles.includes(user.role))
                  .map((subPath) => (
                    <Link
                      key={subPath.path}
                      to={`${path.path}/${subPath.path}`}
                      className={isPathActive(`${path.path}/${subPath.path}`)}
                    >
                      {subPath.label}
                    </Link>
                  ))}
              </div>
            )
          ))}
      </div>
      <br/>
      <button onClick={handleLogout}>Logout</button>
      <br/>
      <br/>
    </div>
  );
}

export default Nav;
